<template>
  <div
    class="mx-auto mb-6 grid grid-cols-1 max-w-content-container items-start justify-between gap-x-0 gap-y-6 md:grid-cols-2 md:gap-x-4 md:gap-y-0"
    :class="[$attrs.class]"
    data-testid="banner-images"
  >
    <div class="flex w-full flex-col gap-y-3" :class="[containerSlotClasses]">
      <slot />
    </div>
    <div
      class="w-full gap-x-3 md:gap-x-low h-full"
      :class="{
        'grid grid-cols-2': smallImagesExist,
      }"
      data-testid="container-banner-images"
    >
      <img
        :src="imageBig"
        class="md:rounded-8 h-full aspect-[180/220] w-full rounded-xl object-cover md:aspect-auto"
        :class="[classImageHeight]"
        :alt="altBig"
      />

      <div v-if="altSmallOne && altSmallTwo" class="relative w-full h-full">
        <div class="absolute grid h-full w-full grid-rows-2 gap-y-3 md:gap-y-6">
          <img
            :src="imageSmallOne"
            class="md:rounded-8 h-full w-full rounded-xl object-cover"
            :alt="altSmallOne"
          />
          <img
            :src="imageSmallTwo"
            class="md:rounded-8 h-full w-full rounded-xl object-cover"
            :alt="altSmallTwo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type TImage = {
  url: string
  alt?: string
}

const props = defineProps<{
  images: {
    one: TImage
    two: TImage
    three: TImage
  }
  imageClasses?: string
  containerImageClasses?: string
  containerSlotClasses?: string
  expandImages?: boolean
}>()

const imageBig = computed(() => props.images.one.url)
const altBig = computed(() => props.images.one?.alt ?? '')
const imageSmallOne = computed(() => props.images.two.url)
const altSmallOne = computed(() => props.images.two?.alt ?? '')
const imageSmallTwo = computed(() => props.images.three.url)
const altSmallTwo = computed(() => props.images.three?.alt ?? '')
const smallImagesExist = computed(() => altSmallOne.value && altSmallTwo.value)

const classImageHeight = computed(() =>
  props.expandImages ? ' md:min-h-[340px] lg:min-h-[772px]' : '',
)
</script>
